import { render, staticRenderFns } from "./dialog-confirmation.vue?vue&type=template&id=826d31d6&scoped=true&"
import script from "./dialog-confirmation.vue?vue&type=script&lang=ts&"
export * from "./dialog-confirmation.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-confirmation.vue?vue&type=style&index=0&id=826d31d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826d31d6",
  null
  
)

export default component.exports